/* eslint-disable indent */
import React from 'react';

const SiteMarker = ({ classes }) => {
  return <div className={classes.siteMarkerIconWrapper} />;
};

export default SiteMarker;
